export { default as Tag } from './Tag';
export { default as TagHideButton } from './TagHideButton';
export { default as HoverableTag } from './HoverableTag';



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/index.js